import { Alert } from '@mui/material';
import Grid from '@mui/material/Grid2';

import SearchAsYouTypeBox from "../../../Lib/UI/Components/SearchAsYouTypeBox";
import OfflineNotice from '../../../Lib/UI/Components/OfflineNotice';
import useSearchPlacesList, { SearchPlacesListProps } from "../hooks/useSearchPlacesList";
import HeaderDivider from '../../../Lib/UI/Components/HeaderDivider';
import AsyncStatus from '../../../Lib/UI/Components/AsyncStatus';
import CustomList from '../../../Lib/UI/Components/CustomList';
import SearchPlacesListItem from './searchPlacesListItem';


const SearchPlacesList = (props: SearchPlacesListProps): JSX.Element => {

    const list = useSearchPlacesList(props);

    return (
        <>
            <Grid                     
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
            >
                <SearchAsYouTypeBox id="placesSearch" onSearch={list.startSearch} minQueryLength={list.searchTermsMinLength} />

                {!list.searchStatus.hasStarted && <Alert severity='info'>Enter a place name to search</Alert>}
                <OfflineNotice text="Search may take a while to produce results or fail to do so" />
            </Grid>

        {list.searchStatus.hasStarted && 
            <>
                <HeaderDivider title="Results" />

                <AsyncStatus action={list.searchStatus} showChildrenWhenComplete={true} busyLabel="Searching..." retry={() => list.startSearch(list.lastTerms)} >

                {!!list.results && 
                    <CustomList>
                    {list.results.map((item, _idx) =>
                        <SearchPlacesListItem key={item.id} item={item} onView={props.onView}/>
                    )}
                    </CustomList>
                }

                </AsyncStatus>
            </>
        }
        </>
    );
};

export default SearchPlacesList;